module.exports = __webpack_public_path__ + "3bc55989c640811de14ab587846be0ea.eot";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-bold.eot
// module id = 17
// module chunks = 0